import { render, staticRenderFns } from "./MHomeIcon.vue?vue&type=template&id=13a2858e&"
import script from "./MHomeIcon.vue?vue&type=script&lang=js&"
export * from "./MHomeIcon.vue?vue&type=script&lang=js&"
import style0 from "./MHomeIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports